import { Duplicate } from '@icons';
import { CaseDuplicatesList } from '@lp/features/CaseDuplicatesList';
import { Case, CaseDuplicateType } from '@/api/apis/case';

type CasesDuplicatesProps = {
  duplicates?: CaseDuplicateType[];
  onDuplicateClick?: (duplicate: Case) => void;
};

export const CaseCardDuplicates = ({ duplicates = [], onDuplicateClick }: CasesDuplicatesProps) => {
  if (!duplicates.length) return null;

  return (
    <CaseDuplicatesList
      duplicates={duplicates}
      onDuplicateClick={onDuplicateClick}
      className="p-0"
      triggerType="hover"
      trigger={
        <div className="flex justify-center items-center p-1 bg-warning-80 rounded-3xl cursor-pointer">
          <Duplicate className="text-warning-20" height={13} />
        </div>
      }
    />
  );
};
